// common/hooks/useAuthentification.js (exemple)
import { useEffect, useState, useCallback } from "react";
import { LOCAL_STORAGE_KEYS } from "../constants";
import { UserService } from "../services";

export default function UseAuthentification() {
    const [currentUser, setCurrentUser] = useState(() => {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
        return raw ? JSON.parse(raw) : null;
    });
    const [initialized, setInitialized] = useState(false);

    const onLogin = useCallback((loginResp, navigate) => {
        const token = loginResp?.accessToken;
        if (token) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN, token);
        }
        // selon ton backend, soit tu as "user" retourné, soit tu rappelles /users/me :
        const user = loginResp?.data || loginResp; // adapte si besoin
        localStorage.setItem(LOCAL_STORAGE_KEYS.CURRENT_USER, JSON.stringify(user));
        setCurrentUser(user);
        setInitialized(true);
        navigate("/dashboard");
    }, []);

    const onLogout = useCallback(() => {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
        setCurrentUser(null);
        setInitialized(true);
    }, []);

    useEffect(() => {
        // réhydratation au F5
        const token = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
        const hasUser = !!localStorage.getItem(LOCAL_STORAGE_KEYS.CURRENT_USER);
        if (!token) {
            setInitialized(true);
            return;
        }
        if (hasUser) {
            setInitialized(true);
            return;
        }
        // token présent mais pas d'user en cache -> on récupère /users/me
        (async () => {
            try {
                const me = await UserService.getUserInfo();
                localStorage.setItem(LOCAL_STORAGE_KEYS.CURRENT_USER, JSON.stringify(me));
                setCurrentUser(me);
            } catch {
                // si 401, exeRequest redirigera; on se met tout de même "ready"
            } finally {
                setInitialized(true);
            }
        })();
    }, []);

    const isAuthenticated = !!localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

    return { currentUser, setCurrentUser, onLogin, onLogout, isAuthenticated, initialized };
}
